import { useTranslations } from "use-intl";
import { ActiveNotificationIcon, FavoriteIcon, GroupsIcon, MusicLibraryIcon } from "@/components/appIcons";
import { Logo } from "@/components/logo";
import { LoginContent } from "./login-content";
interface LoginSearch {
  mode?: "signin" | "signup";
  redirect?: string;
}
import { Route } from "/app/apps/web/src/routes/_app/login/index.tsx";
function LoginRoute() {
  const t = useTranslations("globals.auth");
  const search = Route.useSearch();
  const valueItems = [{
    icon: MusicLibraryIcon,
    label: t("authValueCollection")
  }, {
    icon: FavoriteIcon,
    label: t("authValueWishlist")
  }, {
    icon: ActiveNotificationIcon,
    label: t("authValueAlerts")
  }, {
    icon: GroupsIcon,
    label: t("authValueCommunity")
  }];
  return <div className="flex min-h-[calc(100vh-57px)]">
      <div className="hidden lg:flex lg:w-1/2 bg-primary/5 relative overflow-hidden items-center justify-center">
        <div className="vinyl-texture absolute inset-0" />
        <div className="relative z-10 flex flex-col items-center gap-6 px-12 text-center">
          <Logo className="size-20 text-primary" />
          <p className="text-4xl font-bold tracking-tight">Garimpa.Club</p>
          <p className="text-lg text-muted-foreground max-w-sm">{t("loginTagline")}</p>
          <div className="grid w-full max-w-sm gap-3 pt-2 text-left">
            {valueItems.map(item => {
            const Icon = item.icon;
            return <div key={item.label} className="flex items-center gap-3 rounded-lg border border-border/70 bg-background/60 px-4 py-3">
                  <Icon className="text-xl text-primary" />
                  <span className="text-sm font-medium">{item.label}</span>
                </div>;
          })}
          </div>
        </div>
      </div>

      <div className="flex flex-1 items-start justify-center px-5 py-6 sm:px-6 sm:py-8 lg:items-center lg:py-12">
        <div className="w-full max-w-md">
          <div className="mb-5 flex items-center justify-center gap-2 lg:hidden">
            <Logo className="size-8 text-primary" />
            <h2 className="text-base font-bold tracking-tight">Garimpa.Club</h2>
          </div>

          <LoginContent initialMode={search.mode} redirectAfterLogin={search.redirect} />
        </div>
      </div>
    </div>;
}
export { LoginRoute as component };